<template>
  <ModalAnalisarMA
    :payload="payload"
    :config="config"
    @baixarMinuta="$emit('baixarMinuta')"
    @onLoad="$emit('onLoad')"
    v-if="uf == 'MA'"
  >
    <template v-slot:title> <slot name="title"></slot> </template>
  </ModalAnalisarMA>
  <ModalAnalisarMT
    :payload="payload"
    :config="config"
    @baixarMinuta="$emit('baixarMinuta')"
    @onLoad="$emit('onLoad')"
    v-else-if="uf == 'MT'"
  >
    <template v-slot:title> <slot name="title"></slot> </template>
  </ModalAnalisarMT>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="analise.aceitar ? 1200 : 600"
    v-else
  >
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tooltip">
          <div
            v-bind="tooltip.attrs"
            v-on="analise.disabled && tooltip.on"
            class="title-btn"
          >
            <v-btn
              v-on="on"
              outlined
              :color="analise.color"
              :disabled="analise.disabled"
              class="mr-3"
            >
              <slot name="title"></slot>
            </v-btn>
          </div>
        </template>
        É necessáro o preenchimento das informações obrigatórias nos dados
        cadastrais.
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="onClose" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <template v-if="analise.iniciar">
          <v-row>
            <v-col>
              <h3>O envio do contrato assinado é obrigatório.</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-file-input
                accept="application/pdf, application/vnd.ms-excel"
                label="Contrato assinado*"
                v-model="analise.minuta"
                hide-details="auto"
              >
              </v-file-input>
            </v-col>
          </v-row>
        </template>
        <template v-else-if="analise.aceitar">
          <v-row>
            <v-col>
              <strong
                >Custo do Investimento Municipal
                {{
                  payload.investimentoMunicipio &&
                  payload.investimentoMunicipio.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}</strong
              >
            </v-col>
          </v-row>
          <v-form ref="form">
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="analise.parcelas"
                  label="SELECIONE A QUANTIDADE DE PARCELAS"
                  placeholder="Selecione.."
                  :items="getParcelas(payload.investimentoMunicipio)"
                  item-text="label"
                  item-value="value"
                  hide-details="auto"
                  :return-object="true"
                  :rules="[obrigatorio]"
                >
                  <template slot="no-data">
                    Nenhuma parcela retornada
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-data-table
                  :headers="headers"
                  :items="solucoes"
                  class="elevation-1 w-100 proposta"
                  hide-default-footer
                  disable-pagination
                >
                  <template v-slot:item.numero="{ item, index }">
                    <v-col> {{ index + 1 }} </v-col>
                  </template>
                  <template v-slot:item.parcela="{ item }">
                    <v-col> {{ item.parcela }} </v-col>
                  </template>

                  <template v-slot:item.custo="{ item }">
                    <v-col>
                      {{
                        item.valor.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </v-col>
                  </template>

                  <template v-slot:item.dataInicio="{ item }">
                    <v-col>
                      <v-text-field
                        v-model="item.dataInicio"
                        outlined
                        label="Data Ínicio"
                        name="dataInicio"
                        type="text"
                        hide-details="auto"
                        v-mascara="'##/####'"
                        placeholder="MM/AAAA"
                        :rules="[obrigatorio, rulesData]"
                      ></v-text-field>
                    </v-col>
                  </template>
                  <template v-slot:item.dataFim="{ item }">
                    <v-col>
                      <v-text-field
                        v-model="item.dataFim"
                        outlined
                        label="Data Fim"
                        name="dataFim"
                        type="text"
                        hide-details="auto"
                        v-mascara="'##/####'"
                        placeholder="MM/AAAA"
                        :rules="[obrigatorio, rulesData]"
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-else-if="analise.baixarMinuta">
          <v-row>
            <v-col>
              <h3>
                É necessário adicionar ao menos um representante do SEBRAE/SC
                para gerar a minuta do contrato.
              </h3>
            </v-col>
          </v-row>

          <v-row v-if="payload.investimentoMunicipio < 92000">
            <v-col>
              <ComboboxGerente
                :filter="analise.gerente1"
                :title="'Representante do SEBRAE/SC 1'"
                @onChange="(e) => addGerente(e, 1)"
                :defaultRepresentante="representante1Atual"
                :disabled="
                  analise.status == statusPropostasEnum.execucaoIniciada
                "
              ></ComboboxGerente>
            </v-col>
            <v-col>
              <ComboboxGerente
                :filter="analise.gerente2"
                :title="'Representante do SEBRAE/SC 2'"
                @onChange="(e) => addGerente(e, 2)"
                :defaultRepresentante="representante2Atual"
                :disabled="
                  analise.status == statusPropostasEnum.execucaoIniciada
                "
              ></ComboboxGerente>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col>
              <v-textField
                label="Representante do SEBRAE/SC 1"
                v-model="analise.nomeRepresentante1"
                hide-details="auto"
                disabled
              >
              </v-textField>
            </v-col>
            <v-col>
              <v-textField
                label="Representante do SEBRAE/SC 2"
                v-model="analise.nomeRepresentante2"
                hide-details="auto"
                disabled
              >
              </v-textField>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col>
              <h3>Deseja adicionar uma justificativa a recusa da proposta?</h3>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
                label="Justificativa"
                v-model="analise.justificativaRecusa"
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn color="error" outlined text @click="onClose">Fechar</v-btn>
        <v-btn
          color="info"
          outlined
          text
          @click="onConfirm"
          :disabled="salvarDisabled()"
        >
          <slot name="title"></slot
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { propostaApi, municipioPropostaGrupoSolucaApi } from "@/apis/proposta";
import { statusPropostasEnum } from "./statusPropostasEnum";
import moment from "moment";
import TabelaValores from "./TabelaValores.vue";
import ComboboxGerente from "@/modules/ur/components/ComboboxGerentes";
import ModalAnalisarMA from "@/modules/city/components/propostas/ma/ModalAnalisarMA";
import ModalAnalisarMT from "@/modules/city/components/propostas/mt/ModalAnalisarMT";

import { solutionAPI } from "@/modules/solution/components/SolutionAPI";
import { dataRegexValidatior } from "@/helpers/validator";

export default {
  name: "ModalAnalisarProposta",
  components: {
    TabelaValores,
    ComboboxGerente,
    ModalAnalisarMA,
    ModalAnalisarMT,
  },
  props: {
    payload: { type: Object, required: true },
    faixa: { type: Object, default: null },
    combos: { type: Array, default: () => [] },
    config: { type: Array, default: () => [] },
    solucoesExtras: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      items: [1, 2],
      representante1Atual: null,
      representante2Atual: null,
      analise: this.payload,
      solucoes: [],
      statusPropostasEnum: statusPropostasEnum,
      obrigatorio: (v) => !!v || "Campo Obrigatório",
      rulesData: (v) => {
        if (!dataRegexValidatior.test(`01/${v}`) || v.length < 7) {
          return "Data inválida";
        }
        return true;
      },
      headers: [
        {
          text: "N°",
          value: "numero",
          align: "center",
          width: "10%",
          sortable: false,
        },
        {
          text: "Eixo",
          value: "grupoSolucao.nome",
          align: "center",
          width: "10%",
          sortable: false,
        },
        { text: "Solucao", value: "nome", align: "center" },
        {
          text: "Data Início",
          value: "dataInicio",
          align: "center",
        },
        {
          text: "Data Fim",
          value: "dataFim",
          align: "center",
        },
      ],
      headersAnexos: [
        {
          text: "Nome do arquivo",
          value: "filename",
          align: "center",
          width: "10%",
          sortable: false,
        },
        { text: "Excluir", value: "excluir", align: "center" },
      ],
    };
  },
  watch: {
    dialog(val) {
      if (val && this.analise.aceitar) {
        this.getSolucoes();
      }
    },
    payload: {
      handler(val) {
        this.analise = val;
        if (val.investimentoMunicipio > 92000) {
          const diretor1 = this.config.find(
            (item) => item.configuracaoId == 11
          );
          const diretor2 = this.config.find(
            (item) => item.configuracaoId == 12
          );
          this.analise.nomeRepresentante1 = diretor1.nome;
          this.analise.cpfRepresentante1 = diretor1.valor;
          this.analise.nomeRepresentante2 = diretor2.nome;
          this.analise.cpfRepresentante2 = diretor2.valor;
        }
        var indexCPf1 =
          this.analise &&
          this.analise.nomeRepresentante1 &&
          this.analise.nomeRepresentante1.indexOf("-");

        var indexCPf2 =
          this.analise &&
          this.analise.nomeRepresentante2 &&
          this.analise.nomeRepresentante2.indexOf("-");

        this.representante1Atual = `${
          indexCPf1 > 0
            ? this.analise.nomeRepresentante1.substring(0, indexCPf1 - 1)
            : this.analise.nomeRepresentante1
        } `;

        this.representante2Atual = `${
          indexCPf2 > 0
            ? this.analise.nomeRepresentante2.substring(0, indexCPf2 - 1)
            : this.analise.nomeRepresentante2
        } `;

        this.analise.cpfRepresentante1 = `${
          indexCPf1 > 0
            ? this.analise.nomeRepresentante1.substring(indexCPf1 + 2)
            : ""
        } `;

        this.analise.cpfRepresentante2 = `${
          indexCPf2 > 0
            ? this.analise.nomeRepresentante2.substring(indexCPf2 + 2)
            : ""
        } `;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["user"]),
    uf() {
      return this.$store.state.uf;
    },
  },
  methods: {
    salvarDisabled() {
      if (this.analise.iniciar && !this.analise.minuta) {
        return true;
      }

      if (
        this.analise.baixarMinuta &&
        (!this.analise.nomeRepresentante1 || !this.analise.nomeRepresentante2)
      ) {
        return true;
      }
      return false;
    },
    addGerente(e, type) {
      if (type == 1) {
        this.analise.nomeRepresentante1 = e.gerente;
        this.analise.cpfRepresentante1 = e.cpf;
      } else {
        this.analise.nomeRepresentante2 = e.gerente;
        this.analise.cpfRepresentante2 = e.cpf;
      }
      this.$forceUpdate();
    },
    onClose() {
      // this.analise = {
      //   ...this.analise,
      //   contratoAssinado: null,
      //   termoAssinado: null,
      //   parcelas: null,
      //   nomeRepresentante1: null,
      //   nomeRepresentante2: null,
      // };
      this.dialog = false;
    },

    ...mapActions(["setLoading"]),
    getParcelas(valorTotal) {
      const qtdParcela = this.qtdParcelas(new Date(), new Date(2026, 10));

      const a = Array.from({ length: qtdParcela }).map((item, index) => {
        const qtdParcelaAtual = index + 1;
        const parcelado = valorTotal / qtdParcelaAtual;

        return {
          label: `${qtdParcelaAtual}x de  ${(
            Math.round(parcelado * 100) / 100
          ).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}`,
          value: qtdParcelaAtual,
        };
      });

      return a;
    },
    getSolucoes() {
      this.setLoading(true);
      solutionAPI.list({}).then((res) => {
        const solutions = res.data;

        let solutionsManipulada = this.analise.municipioPropostaGrupoSolucaoDTO
          .map((id) => {
            const atual = solutions.find(
              (item) => item.solucaoId === id.idSolucao
            );
            const b = {
              ...atual,
              municipioPropostaGrupoSolucaoId:
                id.municipioPropostaGrupoSolucaoId,
              dataInicio: id.dataInicio
                ? id.dataInicio
                : (atual && atual.dataInicio) || null,
              dataFim: id.dataFim
                ? id.dataFim
                : (atual && atual.dataTermino) || null,
            };

            return b;
          })
          .filter((i) => i && i.solucaoId);

        const solucoesExtra = this.analise.municipioPropostaGrupoSolucaoDTO
          .map((id) => {
            const atual = this.solucoesExtras.find(
              (v) => id.solucaoExtraId == v.municipioPropostaSolucoesExtrasId
            );
            return {
              ...atual,
              municipioPropostaGrupoSolucaoId:
                id.municipioPropostaGrupoSolucaoId,
              dataInicio: id.dataInicio
                ? id.dataInicio
                : (atual && atual.dataInicio) || null,
              dataFim: id.dataFim
                ? id.dataFim
                : (atual && atual.dataTermino) || null,
            };
          })

          .filter((i) => i && i.municipioPropostaSolucoesExtrasId);

        solutionsManipulada = [...solutionsManipulada, ...solucoesExtra];

        if (solutionsManipulada.length > 0) {
          this.solucoes = solutionsManipulada.map((item) => {
            return {
              ...item,
              dataInicio: moment(item.dataInicio).format("MM/YYYY"),
              dataFim: moment(item.dataFim).format("MM/YYYY"),
            };
          });
        }

        this.setLoading(false);
      });
    },
    qtdParcelas(d1, d2) {
      // até novembro de 2026
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months + 1;
    },
    salvarAnexos() {
      let formData = new FormData();

      formData.append("minuta", this.analise.minuta);
      formData.append("municipioPropostaId", this.analise.municipioPropostaId);
      formData.append("municipioId", this.analise.municipioId);
      formData.append("usuarioCriacao", this.user.usuarioId);
      formData.append("usuarioEnvioMinuta", this.user.usuarioId);

      propostaApi
        .enviarAnexo(formData)
        .then((item) => {
          this.update();
        })
        .catch((err) => {
          this.$notification.error("Erro ao salvar anexo");
          console.log("Erro no salvar anexo ", err);
          this.setLoading(false);
        });
    },
    update() {
      delete this.analise.nomeArquivo;
      delete this.analise.pastaArquivoMinuta;

      propostaApi
        .update(this.analise)
        .then(() => {
          if (this.analise.baixarMinuta) {
            this.$emit("baixarMinuta");
          } else if (this.analise.aceitar) {
            this.editarCronograma();
          } else {
            this.$emit("onLoad");
          }

          this.dialog = false;
        })
        .catch((err) => {
          this.$notification.error("Erro ao analisar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },

    editarCronograma() {
      const municipioPropostaGrupoSolucao =
        this.analise.municipioPropostaGrupoSolucaoDTO.map((item) => {
          const solucaoAtual = this.solucoes.find(
            (val) =>
              val.municipioPropostaGrupoSolucaoId ==
              item.municipioPropostaGrupoSolucaoId
          );

          return {
            ...item,
            municipioPropostaGrupoSolucaoId:
              solucaoAtual.municipioPropostaGrupoSolucaoId,
            dataInicio: moment(
              `1/${solucaoAtual.dataInicio} 00:00:00`,
              "DD/MM/YYYY HH:mm:ss"
            ).format("YYYY-MM-DD HH:mm:ss"),
            dataFim: moment(
              `1/${solucaoAtual.dataFim} 23:59:00`,
              "DD/MM/YYYY HH:mm:ss"
            )
              .endOf("month")
              .format("YYYY-MM-DD HH:mm:ss"),
          };
        });

      municipioPropostaGrupoSolucaApi
        .update(municipioPropostaGrupoSolucao)
        .then(() => {
          this.$emit("onLoad");

          this.dialog = false;
        })
        .catch((err) => {
          this.$notification.error("Erro ao editar cronograma Proposta");
          console.log("Erro no cronograma ", err);
          this.setLoading(false);
        });
    },
    async check() {
      if (!this.$refs.form) return true;
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async onConfirm() {
      const valid = await this.check();
      if (!valid) return;
      this.setLoading(true);
      if (this.analise.aceitar || this.analise.rejeitar) {
        this.analise.dataAnalise = moment().format("YYYY-MM-DD HH:mm:ss");
        this.analise.qtdParcelas =
          (this.analise &&
            this.analise.parcelas &&
            this.analise.parcelas.value) ||
          null;
        this.analise.usuarioAnalise = this.user.usuarioId;
      }
      if (this.analise.aceitar)
        this.analise.status = statusPropostasEnum.aprovado;
      if (this.analise.rejeitar)
        this.analise.status = statusPropostasEnum.rejeitado;
      if (this.analise.iniciar) {
        this.analise.dataExecucao = moment().format("YYYY-MM-DD HH:mm:ss");
        this.analise.status = statusPropostasEnum.execucaoIniciada;
        this.analise.usuarioExecucao = this.user.usuarioId;
      }
      if (
        this.analise.baixarMinuta &&
        this.analise.status != statusPropostasEnum.execucaoIniciada
      ) {
        var indexCPf1 = this.analise.nomeRepresentante1.indexOf("-");

        var indexCPf2 = this.analise.nomeRepresentante2.indexOf("-");

        this.analise.nomeRepresentante1 = `${
          indexCPf1 > 0
            ? this.analise.nomeRepresentante1.substring(0, indexCPf1 - 1)
            : this.analise.nomeRepresentante1
        } - ${this.analise.cpfRepresentante1}`;
        this.analise.nomeRepresentante2 = `${
          indexCPf2 > 0
            ? this.analise.nomeRepresentante2.substring(0, indexCPf2 - 1)
            : this.analise.nomeRepresentante2
        } - ${this.analise.cpfRepresentante2}`;
      }

      if (this.analise.iniciar) {
        this.salvarAnexos();
      } else {
        this.update();
      }
    },
  },
};
</script>
<style lang="scss">
.title-btn {
  max-width: 150px;
  white-space: normal;
  margin: 10px 0;

  .v-btn {
    width: 100%;
    height: 100% !important;
    padding: 5px 16px !important;
    .v-btn__content {
      width: 100%;
      white-space: normal;
    }
  }
}
</style>
